import useUpdateDropTaskSubmissions from '../../../../hooks/useUpdateDropTaskSubmissions'
import SharedVerifyWalletTask, {
  Props,
} from '../../../../shared_components/Missions/Types/VerifyWallet'
import TaskAllocationAmount from '../../../../shared_components/Missions/TaskAllocationAmount'

export default function VerifyWalletTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdateDropTaskSubmissions()
  return (
    <SharedVerifyWalletTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} rewardDisplay='XP' />}
    />
  )
}
